export class Duration
{
  static daysToSeconds( days:number )
  {
    let hours = days * 24;
    return Duration.hoursToSeconds( hours );
  }
  
  static hoursToSeconds( hours:number )
  {
    let minutes = hours * 60;
    return Duration.minutesToSeconds( minutes );
  }

  static minutesToSeconds( minutes:number )
  {
    return minutes * 60;
  }

  static milliSecondsToSeconds( milliseconds:number )
  {
    return milliseconds / 1000;
  }

  
  static secondsToMintues( seconds:number )
  {
    return seconds / 60;
  }

  static secondsToHours( seconds:number )
  {
    let minutes = this.secondsToMintues( seconds );
    return minutes / 60;
  }

  static secondsToDays( seconds:number )
  {
    let hours = this.secondsToHours( seconds );
    return hours / 24;
  }

  static format( duration:number )
  {
    if ( isNaN( duration ) )
    {
      return "--:--";
    }

    let minutes = Math.floor( duration / 60 );
    let seconds = Math.floor( duration - minutes );

    let minutesLabel = minutes + "";
    let secondsLabel = seconds + "";

    while ( minutesLabel.length < 2 )
    {
      minutesLabel = "0" + minutesLabel;
    }

    while ( secondsLabel.length < 2 )
    {
      secondsLabel = "0" + secondsLabel;
    }

    return minutesLabel + ":" + secondsLabel;
  }

}
